var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import FlieUpload from '~/components/common/file-upload.vue';
import { Emit, Prop, Watch, } from "vue-property-decorator";
import DataBox from '~/components/common/data-box.vue';
import { CarManageService } from '~/services/domain-service/car-manage.service';
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { FileUploadService } from "~/services/file-service/file-upload.service";
var CollectionExecutionModule = namespace("collection-execution");
var WarehousingApply = /** @class */ (function (_super) {
    __extends(WarehousingApply, _super);
    function WarehousingApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromData = {
            id: '',
            garageInfoId: '',
            userId: '',
            inspectionDate: '',
            kilometres: '',
            valuationPrice: '',
            warehouseCarStatus: 'IN_WAREHOUSE_WAIT_APPROVED',
            remark: '',
            imageIds: [],
            haveNotFlag: '',
            caseId: '',
            keysNumber: ''
        };
        _this.fileList = [];
        _this.loading = false;
        _this.rules = {
            garageInfoId: { required: true, message: '请选择车库' },
            userId: { required: true, message: '请选择库管' },
            inspectionDate: { required: true, message: '请选择年检到期日期' },
            kilometres: [
                { required: true, message: '请输入公里数' },
                { validator: _this.validatePass }
            ],
            keysNumber: { required: true, message: '请选择钥匙数量' },
            haveNotFlag: { required: true, message: '请选择是否有驾驶证' },
            valuationPrice: [{ validator: _this.validatePass }]
        };
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now() - 3600 * 1000 * 24;
            },
        };
        _this.garageList = [];
        _this.userList = [];
        return _this;
    }
    WarehousingApply.prototype.EmitClose = function () {
        this.reset();
    };
    WarehousingApply.prototype.change = function (val) {
        var _this = this;
        if (!val) {
            this.userList = [];
            this.fromData.userId = '';
        }
        else {
            this.carManageService.getGarageUsersById(val).subscribe(function (data) {
                _this.userList = data;
            });
        }
    };
    WarehousingApply.prototype.validatePass = function (rule, value, callback) {
        var validateNumber = /^[0-9]*$/;
        if (!validateNumber.test(value))
            callback(new Error('必须是数字！'));
        callback();
    };
    WarehousingApply.prototype.commit = function () {
        var _this = this;
        var from = this.$refs['ruleForm'];
        from.validate(function (valid) {
            if (!valid)
                return;
            _this.loading = true;
            _this.carManageService.updateWarehouseCar(_this.dataPramas()).subscribe(function (data) {
                _this.closeLoading();
                _this.$message.success('操作成功！');
                _this.EmitClose();
            }, _this.closeLoading);
        });
    };
    WarehousingApply.prototype.getGarageList = function () {
        var _this = this;
        this.referData();
        this.carManageService.getAllGaragesList().subscribe(function (data) {
            _this.garageList = data;
        });
    };
    WarehousingApply.prototype.referData = function () {
        if (this.isCarManageMenu) {
            this.fromData.id = this.rowData.id;
            this.fromData.garageInfoId = this.rowData.garageInfoId;
            this.fromData.userId = this.rowData.userId;
            this.fromData.inspectionDate = this.rowData.inspectionDate;
            this.fromData.kilometres = this.rowData.kilometres;
            this.fromData.keysNumber = this.rowData.keysNumber;
            this.fromData.remark = this.rowData.remark;
            this.fromData.haveNotFlag = this.rowData.haveNotFlag;
            this.fromData.warehouseCarStatus = "IN_WAREHOUSE_WAIT_APPROVED";
            this.fromData.valuationPrice = this.rowData.valuationPrice;
            this.imageFileList(this.rowData.imageIds);
        }
    };
    WarehousingApply.prototype.closeLoading = function () {
        this.loading = false;
    };
    WarehousingApply.prototype.imageFileList = function (val) {
        var _this = this;
        if (!val)
            return;
        this.fileUploadService.getAllUploadFileByIds(val).subscribe(function (data) {
            _this.fileList = data;
            _this.fileList.map(function (v) {
                v.response = {};
                v.response.id = v.id;
                v.response.url = v.url;
            });
        });
    };
    WarehousingApply.prototype.dataPramas = function () {
        var _this = this;
        var params = __assign({}, this.fromData);
        params.valuationPrice = parseInt(this.fromData.valuationPrice);
        params.kilometres = parseInt(this.fromData.kilometres);
        params.inspectionDate = this.$filter.dateFormat(this.fromData.inspectionDate);
        params.imageIds = this.fileList.map(function (v) { return v.response.id; });
        params.caseId = this.isCarManageMenu ? this.rowData.caseId : this.caseIds[0];
        var user = this.userList.find(function (v) { return v.userId === _this.fromData.userId; });
        params.userName = user.realName;
        return params;
    };
    WarehousingApply.prototype.reset = function () {
        var from = this.$refs['ruleForm'];
        from.resetFields();
        this.fileList = [];
    };
    __decorate([
        Prop({ default: false })
    ], WarehousingApply.prototype, "isCarManageMenu", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], WarehousingApply.prototype, "carManageService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], WarehousingApply.prototype, "fileUploadService", void 0);
    __decorate([
        Prop()
    ], WarehousingApply.prototype, "carFrameNo", void 0);
    __decorate([
        Prop()
    ], WarehousingApply.prototype, "caseIds", void 0);
    __decorate([
        Prop()
    ], WarehousingApply.prototype, "rowData", void 0);
    __decorate([
        Emit('close')
    ], WarehousingApply.prototype, "EmitClose", null);
    __decorate([
        Watch('fromData.garageInfoId')
    ], WarehousingApply.prototype, "change", null);
    WarehousingApply = __decorate([
        Component({
            components: {
                FlieUpload: FlieUpload,
                DataBox: DataBox
            }
        })
    ], WarehousingApply);
    return WarehousingApply;
}(Vue));
export default WarehousingApply;
